// extracted by mini-css-extract-plugin
export default {"dropDownSelect":"DropDownCurrency_dropDownSelect__0iog6","footerDropDown":"DropDownCurrency_footerDropDown__OF1Ww"};